// AUTO-GENERATED by apps-registry.mjs - DO NOT EDIT BY HAND. Regenerated on every build/boot.
import app0 from '../../apps/chat/index.js';
export const discoveredApps = [app0];
